import React, { useState } from "react";
import BackLink from "../shared/BackLink";
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  TextField,
} from "@mui/material";
import { textFieldProps, networksNoCodes } from "../shared/constants";
import { Save } from "@mui/icons-material";
import FileUploader from "../shared/FileUploader";
import { useDb } from "../../contexts/DatabaseContext";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

export default function AddGuide() {
  const { addStandardDoc } = useDb();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileUploadUrl = (url) => {
    setFormState({
      ...formState,
      image: url,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await addStandardDoc("guides", formState);
      navigate(-1);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  return (
    <div>
      <h1>Add Guide</h1>
      <BackLink />

      <Container>
        <Card>
          <form onSubmit={handleSubmit}>
            <CardContent>
              <TextField
                {...textFieldProps}
                name="title"
                onChange={handleChange}
                label="Title"
                required
              />
              <TextField
                {...textFieldProps}
                name="description"
                onChange={handleChange}
                label="Description"
                required
              />
              <Select
                options={networksNoCodes}
                placeholder="Select Network ..."
                onChange={(val) =>
                  setFormState({
                    ...formState,
                    network: val.value,
                  })
                }
              />
              <FileUploader getUrl={handleFileUploadUrl} />
            </CardContent>
            <CardActions>
              <Button
                disabled={loading || !formState.image}
                type="submit"
                startIcon={<Save />}
                variant="contained"
              >
                Save
              </Button>
            </CardActions>
          </form>
        </Card>
      </Container>
    </div>
  );
}
